import { defaults as lodashDefaults } from "lodash";
import { css } from "styled-components";

interface Config {
  duration?: number;
  delay?: number;
  easing?: string;
  y?: number;
  opacity?: number;
}

/**
 * Usage:
 * `const MyStyledComponent = styled.div<OtherProps & InOffAnimationProps>`
 */
export interface InOffAnimationProps {
  visible: boolean;
}

/**
 * onOffAnimation is a prop-driven on/off transition intended to be used inside SC tagged strings
 * A `visible` prop should be passed to the SC componenent
 */
export const onOffAnimation = (onConfig: Config, offConfig: Config) => (props: InOffAnimationProps) => {
  const defaults = {
    duration: 200,
    delay: 0,
    easing: "cubic-bezier(0.165, 0.84, 0.44, 1)",
    y: 0,
    opacity: 1
  };

  const offDefaults = {
    y: 10,
    opacity: 0
  };

  const on = lodashDefaults(onConfig, defaults);
  const off = lodashDefaults(offConfig, offDefaults, onConfig, defaults);

  const onCSS = css`
    transition: transform ${on.duration}ms ${on.delay}ms ${on.easing}, opacity ${on.duration}ms ${on.delay}ms ${on.easing};
    opacity: ${on.opacity};
    transform: translateY(${on.y}px);
  `;

  const offCSS = css`
    transition: transform ${off.duration}ms ${off.delay}ms ${off.easing}, opacity ${off.duration}ms ${off.delay}ms ${off.easing};
    opacity: ${off.opacity};
    transform: translateY(${off.y}px);
  `;

  return props.visible ? onCSS : offCSS;
};



// WEBPACK FOOTER //
// ./src/styles/animations.ts